
import {
    GET_ALL_ACTIVE_FLAT_SIZE
   } from "../../constant/ActionType";
   
   export default function GetAllFlatSize(state = {
       AllActiveFlatSizeData: [],
   
   }, action) {
       switch (action.type) {
           case GET_ALL_ACTIVE_FLAT_SIZE:
               return {
                   ...state,
                   AllActiveFlatSizeData: action?.data?.data,
               };
   
           default:
       }
   
       return state;
   }